// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__hT-Cv","title":"BackImages_title__3BIGe","images":"BackImages_images__3KWch"};